<!-- 搜汽配 -->
<template>
    <div id="qpSearch" class="business-content-main">
        <div class="scroll-view">
            <div class="head">
                <div class="bread-nav">
                    <breadcrumb></breadcrumb>
                </div>
                <div class="search-ctn">
                    <div class="search-ctn-left">
                        <div class="search-name">汽配编码</div>
                        <el-input class="search-item" size="small" v-model.trim="searchData.code" placeholder="请输入汽配编码"></el-input>
                        <div class="search-name">汽配名称</div>
                        <el-input class="search-item" size="small" v-model.trim="searchData.name" placeholder="请输入汽配名称"></el-input>
                        <div class="search-name">适用车型</div>
                        <el-input class="search-item" size="small" v-model.trim="searchData.autoSerieName" placeholder="请输入适用车型"></el-input>
                        <div class="search-item" style="width: auto; margin-left: 15px">
                            <el-button
                                size="small"
                                type="primary"
                                @click="$refs.carTypeSelector.show()"
                                title="点击选择"
                                style="background-color: #f5f7fa; color: #909399; border: 1px solid #dcdfe6; font-size: 14px; padding: 8px 15px"
                                >精准车型</el-button
                            >
                            <el-tag
                                :key="tag"
                                v-for="tag in dynamicTags"
                                closable
                                :disable-transitions="false"
                                @close="handleClose(tag)"
                                style="font-size: 14px; background-color: #fff"
                                >{{ tag }}</el-tag
                            >
                        </div>
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
            <div class="qp-ctn" id="qplist" v-if="tableDataLength > 0">
                <el-card class="box-card qp-item" v-for="item in tableData" :key="item.Id">
                    <div @click="gotoDetails(item.Id)">
                        <div class="qp-cover">
                            <img
                                :src="downloadUrl + (item.PublicUrl.length > 0 ? item.PublicUrl + '?imageView2/2/w/200' : '/UploadFile/Commons/Public/Images/200x200.png')"
                                alt=""
                                :onerror="defaultImg"
                            />
                        </div>
                        <div class="qp-msg">
                            <p class="title" :title="item.Cn">{{ item.Cn.length > 20 ? item.Cn.substring(0, 17) + '...' : item.Cn }}</p>
                            <p :title="item.Code">{{ item.Code.length > 20 ? item.Code.substring(0, 17) + '...' : item.Code }}</p>
                            <p class="ops-ctn">
                                <el-button size="mini" @click.stop="askPJ(item)" v-if="permission.ask">{{ permission.ask }}</el-button>
                                <el-button size="mini" @click.stop="addToInventory(item)" v-if="permission.add">{{ permission.add }}</el-button>
                            </p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div v-else class="no-data">暂无对应的搜索结果</div>
            <el-backtop target=".scroll-view" :bottom="100" :visibility-height="250"></el-backtop>
        </div>
        <autoSeries ref="carTypeSelector" @chooseResult="chooseResult" />
        <transInventory v-if="APMsgVisible" :dialogFormVisible="APMsgVisible" :goodsMsg="goodsMsg" @closeDialog="closeAPMsgDialog"></transInventory>
    </div>
</template>
<script>
import autoSeries from '@/components/common/chooseAutoSeries.vue';
import breadcrumb from '@/components/common/breadcrumb';
import transInventory from '@/components/business/search/transInventory';
import mixin from '@/mixins/mixin';
export default {
    name: 'qpSearch',
    components: {
        autoSeries,
        transInventory,
        breadcrumb
    },
    data() {
        return {
            goodsMsg: {},
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            APMsgVisible: false,
            options: [],
            searchData: {
                code: '',
                name: '',
                sId: '',
                autoSerieName: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            itemHeight: 0,
            flowRow: 0,
            flowColumn: 0,
            noMore: false,
            dynamicTags: []
        };
    },
    created() {},
    mounted() {
        // this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('AutoPartsLib');
        //搜索车架号页面传过来的参数
        let AutoSerieData = this.$util.getLocalStorage('AutoSerieData');
        if (!AutoSerieData) {
            //防止多次请求
            this.initView();
        }
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('scroll', this.handleScroll, true);
        next();
    },
    //从这个事件进入突然有错，改为使用 activated 2021/2/4 by qdl
    // beforeRouteEnter(to, from, next) {
    //   next(vm => {
    //     //因为当钩子执行前，组件实例还没被创建
    //     // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
    //     let fullPath = vm.$route.fullPath;
    //     document.onkeydown = event => {
    //       let isDialog =document.querySelector(".v-modal");
    //       let layui=document.querySelectorAll(".layui-layer");
    //       if(fullPath == vm.$route.fullPath&&!isDialog&&layui.length<=1){
    //         if (event && event.keyCode == 13) {
    //           vm.handleSearch();
    //         }
    //       }
    //     };
    //     document.addEventListener("scroll", vm.handleScroll, true);
    //     //搜索车架号页面传过来的参数
    //     let AutoSerieData = vm.$util.getLocalStorage("AutoSerieData");
    //     if (AutoSerieData) {
    //       //清空查询条件,旧数据
    //       vm.resetSearch();
    //       vm.tableData = [];
    //       vm.tableDataLength = 0;
    //       vm.searchData.sId = AutoSerieData.AutoSerieId;
    //        vm.dynamicTags = [
    //         `${AutoSerieData.Brand} | ${AutoSerieData.AutoSerieName} | ${AutoSerieData.Emission} | ${AutoSerieData.ProducedYear}`,
    //       ];
    //       vm.$util.clearLocalStorage("AutoSerieData"); //用完即删
    //       vm.initView();
    //     }
    //   });
    // },
    activated() {
        let fullPath = this.$route.fullPath;
        document.onkeydown = event => {
            let isDialog = document.querySelector('.v-modal');
            let layui = document.querySelectorAll('.layui-layer');
            if (fullPath == this.$route.fullPath && !isDialog && layui.length <= 1) {
                if (event && event.keyCode == 13) {
                    this.handleSearch();
                }
            }
        };
        document.addEventListener('scroll', this.handleScroll, true);
        //搜索车架号页面传过来的参数
        let AutoSerieData = this.$util.getLocalStorage('AutoSerieData');
        if (AutoSerieData) {
            //清空查询条件,旧数据
            this.resetSearch();
            this.tableData = [];
            this.tableDataLength = 0;
            this.searchData.sId = AutoSerieData.AutoSerieId;
            this.dynamicTags = [`${AutoSerieData.Brand} | ${AutoSerieData.AutoSerieName} | ${AutoSerieData.Emission} | ${AutoSerieData.ProducedYear}`];
            this.$util.clearLocalStorage('AutoSerieData'); //用完即删
            this.initView();
        }
    },
    methods: {
        initView() {
            // let clientHeight = document.querySelector("#business").clientHeight;
            let maxWidth = document.querySelector('.scroll-view').clientWidth;
            // let flowRow = Math.floor(clientHeight / 330); //每一页的行数
            let flowRow = 2;
            let flowColumn = Math.floor(maxWidth / 220); //每一页的列数
            this.searchData.limit = flowColumn * flowRow; //当前界面能容纳的item数

            this.getTableData();
        },
        handleScroll() {
            //没有数据，有弹窗打开时return
            if (this.tableData.length == 0 || this.APMsgVisible) return;
            let scrollTop = document.querySelector('.scroll-view').scrollTop; //滚动条顶部的位置
            let scrollHeight = document.querySelector('.scroll-view').scrollHeight; //滚动条高度
            let windowHeight = document.querySelector('.scroll-view').clientHeight; //可视区的高度
            if (scrollTop + windowHeight >= scrollHeight) {
                if (!this.noMore) {
                    this.searchData.page += 1;
                    this.getTableData();
                } else {
                    this.$util.warningMsg('没有更多数据了');
                }
            }
        },
        // 重置表单
        resetSearch() {
            this.dynamicTags = [];
            this.searchData.code = '';
            this.searchData.name = '';
            this.searchData.sId = '';
            this.searchData.page = 1;
            this.searchData.limit = 10;
            this.searchData.autoSerieName = '';
        },
        // 询问配件
        askPJ(item) {
            if (this.$store.state.connectState != 2) {
                this.$util.warningMsg('请先连接到客服再进行询问');
                return;
            }
            this.$store.commit('updateAskPJMsg', item);
            this.$util.successMsg('已向客服发送该商品');
        },
        // 跳转到汽配详情
        gotoDetails(id) {
            this.$router.push(`./qpDetail?id=${id}`);
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    // url: "/api/AutoParts/LoadAutoParts",
                    url: '/api/AutoParts/GetAutoPartsList',
                    data: this.searchData,
                    hideLoading: false
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    if (data) {
                        this.tableData = this.tableData.concat(data);
                    }
                    this.tableDataLength = res.count;
                    this.noMore = this.tableData.length == this.tableDataLength;
                })
                .catch(() => {});
        },
        //配件查重
        checkAPCode() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/ValidateEnterprisePartCode',
                    data: {
                        EntpTempGoodsId: this.goodsMsg.Id,
                        APCode: this.goodsMsg.Code
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        this.$util.errorMsg('您添加的商品已有库存');
                    } else {
                        this.APMsgVisible = true;
                    }
                })
                .catch(err => {});
        },
        // 添加为库存
        addToInventory(item) {
            this.goodsMsg = item;
            this.checkAPCode();
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        handleClose(tag) {
            this.searchData.sId = '';
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        handleSearch() {
            this.searchData.page = 1;
            this.tableData = [];
            document.querySelector('.scroll-view').scrollTop = 0; //滚动条移回顶部
            this.getTableData();
        },
        // 选择车型返回结果
        chooseResult(arr) {
            this.searchData.sId = arr.SId;
            this.dynamicTags = [`${arr.Cn} | ${arr.AutoSerieName} | ${arr.Emission} | ${arr.ProducedYear} | ${arr.SaleModel}`];
            // 关闭弹框
            setTimeout(() => {
                this.$refs.carTypeSelector.hide();
            }, 1000);
        }
    }
};
</script>
<style lang="less" scoped>
.business-content-main {
    height: 100%;
    overflow: hidden;
}
.scroll-view {
    height: 99%;
    overflow-y: scroll;
}
.head {
    position: fixed;
    top: 81px;
    padding: 10px 10px 10px 10px;
    height: 110px;
    // width: 100%;
    width: 90%;
    background-color: white;
    z-index: 1;
    margin-left: -20px;
}
.qp-msg {
    p {
        padding-top: 10px;
    }
    .title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
.qp-ctn {
    width: 100%;
    height: 100%;
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    margin-top: 100px;
    // padding-bottom: 50px;
}

.qp-item {
    cursor: pointer;
    margin-right: 20px;
    margin-bottom: 20px;
    height: 324px;
}
.ops-ctn {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
}
</style>
